module.exports = __webpack_public_path__ + "5000c19c99d2e5a242efdddc443e5ab6.png";